<template>
    <div>
        <tracker-new-data-header v-if="!editTarget" :columns="columns"></tracker-new-data-header>
    </div>
</template>

<script>
import { trackerNewDataCommon } from "./trackerNewDataCommon";

export default {
    name: "TrackerNewDataColdProbe",
    mixins: [trackerNewDataCommon],
    data() {
        return {
            columns: {
                titles: [
                    `Last edited`,
                    `Target`,
                    `Probes`,
                    `Introduced`,
                    `Acquired`,
                    `Retained`,
                    ``,
                ],
                col: [2, 2, 1, 2, 2, 2, 1],
            },
        };
    },
};
</script>

<style scoped></style>
